export default "__VITE_ASSET__11609072__"